<template>
  <!-- 负责人 -->
  <div>
    <div class="fourthStep">
      <el-form
        ref="extTable"
        class="demo-ruleForm"
        :model="{ extTable }"
        :rules="tableRules"
        label-width="100px"
      >
        <!--添加其他人员-->
        <el-form-item
          :class="
            titles == $t('page.content.addOtherPeople') ||
            titles == $t('page.content.addTechnicalLeader')
              ? 'addTabIndex myForm'
              : 'addTabIndex'
          "
          label-width="0px"
          label=""
          prop=""
        >
          <el-table border :data="extTable" class="" max-height="99999">
            <!--序号-->
            <el-table-column
              type="index"
              :label="$t('page.content.No')"
              width="60"
              fixed
            >
            </el-table-column>
            <!--姓名-->
            <el-table-column
              show-overflow-tooltip
              min-width="150"
              prop="personName"
              :label="$t('page.content.userName')"
            >
              <template slot-scope="scope">
                <el-form-item
                  :prop="`extTable.${scope.$index}.personName`"
                  :rules="tableRules.personName"
                >
                  <!--请输入-->
                  <el-input
                    v-model="scope.row.personName"
                    v-if="noDisabled"
                    :placeholder="$t('page.content.enter')"
                    clearable
                    maxlength="18"
                  />
                  <div v-else>{{ scope.row.personName }}</div>
                </el-form-item>
              </template>
            </el-table-column>
            <!--年龄-->
            <el-table-column
              show-overflow-tooltip
              min-width="100"
              prop="personAge"
              :label="$t('page.content.age')"
            >
              <template slot-scope="scope">
                <el-form-item
                  :prop="`extTable.${scope.$index}.personAge`"
                  :rules="tableRules.personAge"
                >
                  <!--请输入-->
                  <el-input
                    oninput="value=value.replace(/[^0-9]/g,'')"
                    v-model="scope.row.personAge"
                    v-if="noDisabled"
                    :placeholder="$t('page.content.enter')"
                    clearable
                  />
                  <div v-else>{{ scope.row.personAge }}</div>
                </el-form-item>
              </template>
            </el-table-column>
            <el-table-column
              align="center"
              :show-overflow-tooltip="true"
              prop="cardType"
              label="证件类型"
              min-width="200"
            >
              <template slot-scope="scope">
                <el-form-item
                  :prop="`extTable.${scope.$index}.cardType`"
                  :rules="tableRules.cardType"
                >
                  <!--请选择-->
                  <el-select
                    v-if="noDisabled"
                    v-model="scope.row.cardType"
                    placeholder="请选择"
                    @change="
                      changeCardType(
                        `extTable.${scope.$index}.idCard`,
                        scope.row
                      )
                    "
                  >
                    <el-option
                      v-for="item in optionsCardType"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value"
                    >
                    </el-option>
                  </el-select>
                  <div v-else>
                    {{ handlerCardType(scope.row.cardType) }}
                  </div>
                </el-form-item>
              </template>
            </el-table-column>
            <!--证件号码-->
            <el-table-column
              show-overflow-tooltip
              prop="idCard"
              :label="$t('page.content.documentNumber')"
              min-width="200"
            >
              <template slot-scope="scope">
                <el-form-item
                  :prop="`extTable.${scope.$index}.idCard`"
                  :rules="
                    scope.row.cardType == 0
                      ? tableRules.idCard
                      : tableRules.idCard2
                  "
                >
                  <!--请输入-->
                  <el-input
                    oninput="value=value.replace(/[^0-9a-zA-Z.]/g,'')"
                    v-model="scope.row.idCard"
                    :placeholder="$t('page.content.enter')"
                    v-if="noDisabled"
                    clearable
                    maxlength="18"
                  />
                  <div v-else>{{ scope.row.idCard }}</div>
                </el-form-item>
              </template>
            </el-table-column>
            <!--拟在本包件工程任职-->
            <el-table-column
              :min-width="languagezh_cn ? 170 : 200"
              prop="packPostTitle"
              show-overflow-tooltip
              :label="$t('page.content.proposedWorkInPackage')"
            >
              <template slot-scope="scope">
                <el-form-item
                  :prop="`extTable.${scope.$index}.packPostTitle`"
                  :rules="tableRules.packPostTitle"
                >
                  <!--请输入-->
                  <el-input
                    v-model="scope.row.packPostTitle"
                    :placeholder="$t('page.content.enter')"
                    v-if="noDisabled"
                    clearable
                    maxlength="18"
                  />
                  <div v-else>{{ scope.row.packPostTitle }}</div>
                </el-form-item>
              </template>
            </el-table-column>
            <!--技术职称-->
            <el-table-column
              min-width="150"
              prop="techPostTitle"
              show-overflow-tooltip
              :label="$t('page.content.technicalTitle')"
            >
              <template slot-scope="scope">
                <el-form-item
                  :prop="`extTable.${scope.$index}.techPostTitle`"
                  :rules="tableRules.techPostTitle"
                >
                  <!--请输入-->
                  <el-input
                    v-model="scope.row.techPostTitle"
                    :placeholder="$t('page.content.enter')"
                    clearable
                    v-if="noDisabled"
                    maxlength="18"
                  />
                  <div v-else>{{ scope.row.techPostTitle }}</div>
                </el-form-item>
              </template>
            </el-table-column>
            <!--工作年限-->
            <el-table-column
              show-overflow-tooltip
              min-width="100"
              prop="workYear"
              :label="$t('page.content.workYears')"
            >
              <template slot-scope="scope">
                <el-form-item
                  :prop="`extTable.${scope.$index}.workYear`"
                  :rules="tableRules.workYear"
                >
                  <!--请输入-->
                  <el-input
                    oninput="value=value.replace(/[^0-9]/g,'')"
                    v-model="scope.row.workYear"
                    v-if="noDisabled"
                    :placeholder="$t('page.content.enter')"
                    clearable
                  />
                  <div v-else>{{ scope.row.workYear }}</div>
                </el-form-item>
              </template>
            </el-table-column>
            <!--类似施工经验年限-->
            <el-table-column
              :min-width="languagezh_cn ? 150 : 180"
              show-overflow-tooltip
              prop="contctExperYear"
              :label="$t('page.content.similarYears')"
            >
              <template slot-scope="scope">
                <el-form-item
                  :prop="`extTable.${scope.$index}.contctExperYear`"
                  :rules="tableRules.contctExperYear"
                >
                  <!--请输入-->
                  <el-input
                    oninput="value=value.replace(/[^0-9]/g,'')"
                    v-model="scope.row.contctExperYear"
                    :placeholder="$t('page.content.enter')"
                    v-if="noDisabled"
                    clearable
                  />
                  <div v-else>{{ scope.row.contctExperYear }}</div>
                </el-form-item>
              </template>
            </el-table-column>
            <!--操作-->
            <el-table-column
              fixed="right"
              width="80px;"
              v-if="noDisabled"
              prop="remark"
              :label="$t('page.content.op')"
            >
              <template slot-scope="scope">
                <!--删除-->
                <span
                  style="color: #0089EF;cursor: pointer;"
                  @click="deleteItem(scope)"
                  >{{ $t("page.content.Delete") }}</span
                >
              </template>
            </el-table-column>
          </el-table>
        </el-form-item>
        <el-form-item v-if="noDisabled" label-width="0px" label="">
          <div class="addBtn" @click="addTable()">+{{ titles }}</div>
        </el-form-item>
      </el-form>
    </div>
  </div>
</template>

<script>
import Cookies from "js-cookie";
export default {
  props: {
    extTable: {
      type: Array,
      default: () => []
    },
    //添加人员
    titles: {
      type: String,
      default: window.$t("page.content.addPersonnel")
    },
    noDisabled: {
      type: Boolean,
      default: false
    }
  },

  data() {
    // 有效订单
    const validateIDCard = (rule, value, callback) => {
      let _IDRe18 = /^([1-6][1-9]|50)\d{4}(18|19|20)\d{2}((0[1-9])|10|11|12)(([0-2][1-9])|10|20|30|31)\d{3}[0-9Xx]$/;
      let _IDre15 = /^([1-6][1-9]|50)\d{4}\d{2}((0[1-9])|10|11|12)(([0-2][1-9])|10|20|30|31)\d{3}$/;
      // 校验身份证：
      if (_IDRe18.test(value) || _IDre15.test(value)) {
        callback();
      } else {
        callback(new Error("验证未通过"));
      }
    };
    return {
      checkOut: false,
      optionsCardType: [
        {
          value: 0,
          label: "身份证"
        }
        // {
        //   value: 2,
        //   label: "其他"
        // }
      ],
      tableRules: {
        //请输入姓名
        personName: [
          {
            required: true,
            message: window.$t("page.content.enterName"),
            trigger: "blur"
          }
        ],
        //请输入年龄
        personAge: [
          {
            required: true,
            message: window.$t("page.content.enterAge"),
            trigger: "blur"
          }
        ],
        //请输入证件类型
        cardType: [
          {
            required: true,
            message: "请选择证件类型",
            trigger: "change"
          }
        ],
        //请输入证件号码
        idCard: [
          {
            required: true,
            message: window.$t("page.content.enterId"),
            trigger: "blur"
          },
          {
            min: 9,
            max: 18,
            required: true,
            message: "请输入正确的证件号码",
            validator: validateIDCard,
            trigger: "blur"
          }
        ],
        //请输入证件号码
        idCard2: [
          {
            required: true,
            message: window.$t("page.content.enterId"),
            trigger: "blur"
          },
          {
            // min: 9,
            // max: 10,
            required: true,
            message: "证件号码不能为空",
            trigger: "blur"
          }
        ],
        //请输入拟在本包件工程任职
        packPostTitle: [
          {
            required: true,
            message: window.$t("page.content.enterEmploy"),
            trigger: "blur"
          }
        ],
        //请输入技术职称
        techPostTitle: [
          {
            required: true,
            message: window.$t("page.content.enterTech"),
            trigger: "blur"
          }
        ],
        //工作年限
        workYear: [
          {
            required: true,
            message: window.$t("page.content.workYears"),
            trigger: "blur"
          }
        ],
        //类似施工经验年限
        contctExperYear: [
          {
            required: true,
            message: window.$t("page.content.similarYears"),
            trigger: "blur"
          }
        ]
      }
    };
  },
  computed: {
    languagezh_cn() {
      return (Cookies.get("language") || "zh-cn") === "zh-cn";
    }
  },
  methods: {
    // executor (resolve, reject) {
    //   let rand = Math.random()
    //   console.log(1)
    //   console.log(rand)
    //   if (rand > 0.5) {
    //     resolve()
    //   } else {
    //     reject()
    //   }
    // },
    // changeCardType(index) {
    //   this.$refs["extTable"].validateField();
    // },
    handlerCardType(type) {
      let str = "";
      switch (String(type)) {
        case "0":
          str = "身份证";
          break;
        case "2":
          str = "其他";
          break;
        default:
          break;
      }
      return str;
    },
    //对部分表单字段进行校验
    changeCardType(prop, row) {
      console.log(prop, "prop");
      console.log(row, "row");
      console.log(this.$refs["extTable"], 'this.$refs["extTable"]');
      this.$nextTick(() => {
        this.$refs["extTable"].fields.filter(item => {
          if (item.prop == prop) {
            this.$refs["extTable"].validateField([prop]);
          }
        });
      });
    },
    ruleFun(resolve, reject) {
      this.$refs["extTable"].validate(valid => {
        if (valid) {
          this.checkOut = true;
          resolve();
        } else {
          console.log("error submit!!");
          this.checkOut = false;
          reject();
        }
      });
    },
    // 新增
    addTable() {
      if (this.extTable && this.extTable.length === 0) {
        this.extTable.push({
          id: 1,
          attribute1: "01"
        });
      } else {
        this.extTable.push({
          id: this.extTable[this.extTable.length - 1].id + 1,
          attribute1: "01"
        });
      }
      this.$parent.$emit("el.form.change");
    },
    deleteItem(scope) {
      console.log(this.extTable, "this.extTable.....");
      console.log(scope.$index, "scope.....");
      // this.extTable.filter((item, index) => {
      //   if (item.id === scope.row.id) {
      this.extTable.splice(scope.$index, 1);
      // }
      // });
      // this.$parent.$emit("el.form.change");
    },
    // 上一步
    lastStep() {
      this.$emit("getStep", 2);
    }
  }
};
</script>

<style lang="scss" scoped>
.fourthStep {
  display: flex;
  align-items: center; /*垂直居中*/
  justify-content: center; /*水平居中*/
}
.el-form-item__content .el-button {
  width: 82px;
  height: 40px;
  background: #0089ef;
  border-radius: 2px;
  font-size: 14px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #ffffff;
}
.el-form-item__content .stopBtn {
  border: 1px solid #0089ef;
  font-size: 14px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #0089ef;
}

.addBtn {
  cursor: pointer;
  margin: 0px 0px 10px 0px;
  height: 32px;
  line-height: 32px;
  border: 1px dashed #eee;
  border-radius: 4px;
  text-align: center;
  font-size: 14px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #252631;
}
.addTabIndex {
  width: 100%;
  display: flex;
  align-items: center; /*垂直居中*/
  justify-content: center; /*水平居中*/
}
.addTabIndex /deep/.tbody tr {
  height: 45px !important;
}

.addTabIndex /deep/.el-table {
  margin: 0 auto;
  border-bottom: none;
  tbody tr {
    height: 60px !important;
  }
  th > .cell:before {
    content: "*";
    color: red;
    margin-right: 5px;
  }
  // th:nth-child(6) > .cell:before {
  //   content: "";
  //   margin-right: 5px;
  // }
  th:nth-child(1) > .cell:before {
    content: "";
    margin-right: 5px;
  }
  .addBtn {
    width: 100%;
    height: 32px;
    line-height: 32px;
    border: 1px dashed #eee;
    border-radius: 4px;
    margin: 16px 0;
    text-align: center;
    font-size: 14px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #252631;
  }
  .el-table-row .hover-row {
    background: #eee !important;
  }
}

.myForm /deep/.el-table {
  th:nth-child(n) > .cell:before {
    content: "";
    margin-right: 5px;
  }
  th:nth-child(2n) > .cell:before {
    content: "";
    margin-right: 5px;
  }
}
.demo-ruleForm {
  width: 100%;
  /deep/ .el-form-item__content {
    width: 100%;
  }
}
</style>
